import { NavigationTabNew } from '@components/NavigationTabNew';

export function DashboardHeaderBottom() {
    return <NavigationTabNew />;
}
